import { documentResourceToFormValues } from './document-resource-to-form-values';

import type { OfflineStoreData, StoreData } from '../../model/stores-data';
import type {
  OnlinePointOfSalesResponse,
  PointOfSalesResponse,
} from '../../model/types';
import { MALL_OPTION_NONE, MALL_OPTION_OTHER } from '../get-mall-titles-map';

function isOnlinePointOfSales(
  pos: PointOfSalesResponse
): pos is OnlinePointOfSalesResponse {
  return pos.type === 'ONLINE';
}

function pointOfSalesResponseToStoreData(pos: PointOfSalesResponse): StoreData {
  if (isOnlinePointOfSales(pos)) {
    return { details: pos };
  }

  const hasMallId = !!pos.mallId?.trim().length;
  const hasMallNameOther = !!pos.mallNameOther?.trim().length;

  const getMallId = () => {
    if (hasMallId) {
      return pos.mallId ?? '';
    }

    if (hasMallNameOther) {
      return MALL_OPTION_OTHER.id;
    }

    return MALL_OPTION_NONE.id;
  };

  const offlineData: OfflineStoreData = {
    details: {
      type: 'OFFLINE',
      uiId: pos.uiId,
      name: pos.name,
      email: pos.email,
      contactNumber: pos.contactNumber,
      avgMonthlySales: pos.avgMonthlySales,
      tinCode: pos.tinCode,
      websiteURL: pos.websiteURL ?? '',
      numberOfFloors: pos.numberOfFloors,
      hasCCTV: pos.hasCCTV,
      dayOfRecording: pos.dayOfRecording ?? undefined,
      areaSqm: pos.areaSqm ?? 0,
    },
    address: {
      country: pos.address.country,
      region: pos.address.region,
      province: pos.address.province,
      cityOrMunicipality: pos.address.cityOrMunicipality,
      postalCode: pos.address.postalCode,
      barangay: pos.address.barangay,
      streetAndHouse: pos.address.streetAndHouse,
      unitAndFloor: pos.address.unitAndFloor ?? '',
      mallId: getMallId(),
      mallNameOther: pos.mallNameOther ?? '',
    },
    coordinates: pos.coordinates
      ? { lat: pos.coordinates.lat, lng: pos.coordinates.lon }
      : null,
    photos: {
      STORE_AND_MERCHANDISE_DISPLAY:
        pos.photos?.map(documentResourceToFormValues) ?? [],
    },
  };

  return offlineData;
}

export function recoverPointsOfSales(
  pointsOfSales: PointOfSalesResponse[] | undefined
): StoreData[] | undefined {
  if (!pointsOfSales?.length) return undefined;

  return pointsOfSales.map(pointOfSalesResponseToStoreData);
}
